import type { VuiTheme, VuiThemeExtensions } from './types'

import { merge } from '../utils'
import defaultTheme from './defaultTheme'

/** Merges provided theme extensions and overrides with default VUI theme. */
export function extendTheme(extensions: VuiThemeExtensions): VuiTheme {
  return merge(defaultTheme, extensions)
}
